import zIndex from './zIndex';
import colors, { darkColors } from './colors';
import fonts, { kaFonts } from './fonts';
import media from './media';
import borderRadius from './borderRadius';
import { darkThemeShadows, lightThemeShadows } from './shadows';
export const theme = {
    media,
    fonts,
    colors,
    zIndex,
    borderRadius,
    shadows: lightThemeShadows,
};
export const darkTheme = {
    ...theme,
    colors: darkColors,
    shadows: darkThemeShadows,
};
export const kaTheme = {
    ...theme,
    fonts: kaFonts,
};
//# sourceMappingURL=theme.js.map